/**
 * General state selectors
 */
export const getCaseLogFilterResults = state => state.caseLogs.caseLogFilterResults;
export const getCaseLogFilterResultsCount = state => state.caseLogs.caseLogFilterResultsCount;
export const getCaseLogFilterResultsPage = state => state.caseLogs.caseLogFilterResultsPage;
export const getCaseLogServices = state => state.caseLogs.caseLogServices;
